// extracted by mini-css-extract-plugin
export default {"info_icon":"style_info_icon__vYlDM"};